import * as React from "react";
const StopIcon = ({ brandingColor = "#22880" }: { brandingColor?: string }) => (
  <svg
    width="40"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="frame" clipPath="url(#clip0_15123_5522)">
      <path
        id="vector"
        d="M6.4 10H13.6M10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19Z"
        stroke={brandingColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_15123_5522">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default StopIcon;
